import React from 'react';
import '../css/About.css';
import logoBlue from '../img/logoBlue.png';

function About() {
    return (
        <div className="about" id="about">
            <div className="about__left">
                <h1>Hey, I'm Ilir.</h1>
                <h3>I'm a Front End Developer passionate about new technology, about combining beautiful code with beautiful design.</h3>
                <hr />
                <p><span className="spanP">I'm second year student in University of Bussines and Technology - UBT</span> in Kosovo studying computer science. Resourceful Front End Web Developer bringing in-depth
                knowledge of latest technology trends to produce clean
                website design. Experience handling complex HTML
                and CSS coding, design and extensions to meet
                organization's front-facing internet needs. Detail-oriented
                collaboration with others to define project expectations
                and demand. Hands-on testing and debugging to
                address inconsistencies and maintain performance
                thresholds.</p>
                <br/>
                <p>I have experience developing and designing software for the web, from simple landing page to progressive web applicatons. I strive to create software that not only functions efficiently under the hood, but also provides intuitive, pixel-perfect user experiences.</p><br/>
                <p><span className="spanP">When I'm not in front of computer screen,</span>I'm probably playing basketball that's my hobby.</p>
            </div>
            <div className="about__right">
                <img src={logoBlue} alt=""/>
            </div>
        </div>
    )
}

export default About;
